import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTextElement } from './OneUxTextElement.js';
export const register = getRegisterFunction(OneUxTextElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-text': OneUxTextElement;
    "text-450cd6de4665c81b802d4a59bd7bc183": OneUxTextElement;
  }
}